import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";

import { Addendum } from "@/core/types";

import { addendumKeys } from "../keyFactory";
import {
  type CreateNoteAddendumVariables,
  createNoteAddendum,
} from "../queryFunctions/createNoteAddendum";

export function useCreateNoteAddendum({
  onSuccess,
  ...options
}: UseMutationOptions<Addendum, unknown, CreateNoteAddendumVariables> = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createNoteAddendum,
    ...options,
    onSuccess: async (data, variables, context) => {
      /**
       * TODO: Remove when long-polling is available.
       * This is a temporary workaround; see awaitNotesSummaryRefresh for an explanation.
       */
      await new Promise((resolve) => setTimeout(resolve, DELAY_TIME));
      await queryClient.invalidateQueries({
        queryKey: addendumKeys.byNote(variables.noteId),
      });
      onSuccess?.(data, variables, context);
    },
  });
}

const DELAY_TIME = 4_000;
